import { buildTherapyFormSchema, THERAPY_TEXT_MIN_LENGTH } from '../../../../common';

export const THERAPY_FORM_SCHEMA = buildTherapyFormSchema({
  providerNameMinLength: THERAPY_TEXT_MIN_LENGTH,
  includeRecordShared: true,
});
